import crypto from "crypto";
import { pipe, Redacted, Option, Array, String } from "effect";

export function isAlphanumeric(value: string): boolean {
  return /^[a-zA-Z0-9]+$/.test(value);
}

/**
 * Creates hash for a Redacted - first 16 characters of SHA-256
 */
export function hashRedacted(redacted: Redacted.Redacted): string {
  return crypto
    .createHash("sha256")
    .update(Redacted.value(redacted))
    .digest("hex")
    .substring(0, 16);
}

const invalidSymbolRegex = /invalid value[s]? for "symbol": "(?<symbols>.+)"/i;

export function parseInvalidSymbols(
  errorMessage: string | null
): string[] | null {
  return pipe(
    errorMessage,
    Option.fromNullable,
    Option.flatMapNullable((message) => invalidSymbolRegex.exec(message)),
    Option.flatMap(Array.get(1)),
    Option.map(String.toLowerCase),
    Option.map(String.split(",")),
    Option.getOrNull
  );
}

export function wasNotFound(errorMessage: string): boolean {
  return /no items found/i.test(errorMessage);
}
